exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rasa-menu {\n  background-color: var(--grey-800);\n  height: 63px;\n}\n\n.rasa-menu .nav {\n  border: none;\n}\n\n.rasa-menu .nav-tabs .nav-link {\n  color: var(--grey-300);\n  border: none;\n  border-radius: 0;\n}\n.selected {\n  border-bottom: 4px solid var(--cyan-400);\n}\n.selected h3 {\n  font-weight: bold;\n}\n\n.rasa-menu .nav-tabs .nav-link:hover {\n  color: var(--grey-100);\n}\n\n.rasa-menu .navbar-brand {\n  margin-right: 2rem;\n  margin-left: .5rem;\n}\n\n.rasa-menu .nav-tabs .nav-link h3 {\n  display: inline-block;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-family: var(--secondary-font-family);\n  margin-top: 18px;\n  background-color: var(--grey-800);\n}\n.rasa-menu .nav-tabs .nav-link h3:hover {\n  font-weight: bold;\n}\n\n.rasa-menu .user-nav {\n  margin-left: auto;\n}\n\n.rasa-menu .user-nav i {\n  font-size: 2.5rem;\n  color: var(--text-light-grey);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/menu/styles.css
// module id = 1536
// module chunks = 29